import React, { useState } from "react";
import "../component/productUnitHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const ProductUnitHeader = ({
  onAddProductUnitClicked,
  onSearchProductUnitEdited,
}) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("searchValue")
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    e.preventDefault();
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
 localStorage.setItem("searchValue",searchValue)
      e.preventDefault();
      if (searchValue.length > 3) {
      onSearchProductUnitEdited(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
      onSearchProductUnitEdited(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 3 huruf");
      }
    }
  };

  return (
    <div className="product-unit-header-container">
      <button
        className="add-product-unit-button"
        onClick={onAddProductUnitClicked}
      >
        <FaPlusCircle />
        Tambah Produk Unit Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Produk Unit"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          />
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
    </div>
  );
};

export default ProductUnitHeader;
